//Creates new Tip Box and assigns ID and type
export const createIceBucket = (data) => {
    //data = {id, type}
    return { type: "CREATE_ICE_BUCKET", payload: data}
}

export const addTubeToIceBucket = (data) => {
    //data = {cathodeConnected}
    return { type: "ADD_TUBE_TO_ICE_BUCKET", payload: data}
}
export const removeTubeFromIceBucket = (data) => {
    //data = {cathodeConnected}
    return { type: "REMOVE_TUBE_FROM_ICE_BUCKET", payload: data}
}
